import { CCard, CCardBody, CCol, CCardHeader, CRow } from '@coreui/react'
import {
    CChartBar,
    CChartDoughnut,
    CChartLine,
    CChartPie,
    CChartPolarArea,
    CChartRadar,
} from '@coreui/react-chartjs'
import { DocsCallout } from 'src/components';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Flex, Input, Tabs, Upload, Select, Spin, Checkbox, Collapse, Modal } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { apiUrls } from '../../apiUrls.js';
import Program from "../../components/Program.js";
import { useNavigate } from 'react-router-dom';
import { UnlockOutlined, LockOutlined, EditOutlined, SearchOutlined, DeleteOutlined } from '@ant-design/icons';
import AmountFormat from "../../components/AmountFormat.js";
import InputNumberFormat from "../../components/InputNumberFormat.js";
import DatePicker, { utils } from '@hassanmojab/react-modern-calendar-datepicker';
import { UploadOutlined } from '@ant-design/icons';
import jquery from 'jquery';
import HideSidebarInMobileMode from "../../components/HideSidebarInMobileMode.js";

const { Option } = Select;

const baseURL = apiUrls.baseURL;

const MembersWallet = () => {

    const [data, setData] = useState([]);
    const [WalletModel, setWalletModel] = useState({});
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);
    const [id, setId] = useState(0);
    const [count, setCount] = useState(0);
    const [filter, setFilter] = useState({ skip: 0, limit: 20, data: {} });
    const [dropDownWalletType, setDropDownWalletTypes] = useState([]);
    const [reload, setReload] = useState(false);
    const [dropDownUser, setDropDownUsers] = useState([]);
    const [isShowCreateWalletModalVisible, setIsShowCreateWalletModalVisible] = useState(false);
    const permissions = useSelector((state) => state.permissions.permissions);
    const navigate = useNavigate();
    const [loadingFinancialReport, setLoadingFinancialReport] = useState(false);

    useEffect(() => {
        fetchWalletType()
        fetchUsers()
    }, [])

    useEffect(() => {
        fetchData()
    }, [reload])

    useEffect(() => {
        const loadNextPage = () => {
            const isNearBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 200;
            const hasMore = data.length < count;

            if (isNearBottom && hasMore && !loading && !loadingMore) {
                setLoadingMore(true);
                setFilter((current) => ({ ...current, skip: current.skip + 1 }));
                setReload(true);
            }
        };

        window.addEventListener('scroll', loadNextPage);
        loadNextPage();
        return () => window.removeEventListener('scroll', loadNextPage);
    }, [data, count, loading, loadingMore, filter.skip]);

    const fetchData = async () => {
        if (!loadingMore) setLoading(true);

        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.post(`${baseURL}/wallet/get`, filter, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;
            result.items.map(item => {
                item.key = item.id
            })
            setCount(result.count)
            setData((current) => filter.skip === 0 ? result.items : [...current, ...result.items]);
            setLoading(false);
            setReload(false)
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
            setReload(false)
        } finally {
            setLoading(false);
            setLoadingMore(false);
            setReload(false)
        }
    };

    const fetchUsers = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getDropdownItems`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })

            var result = response.data.data;
            setDropDownUsers(result);
        } catch (error) {
        } finally {
        }
    };

    const fetchWalletType = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/wallet/getTypeDropdownItems`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })

            var result = response.data.data;
            setDropDownWalletTypes(result);
        } catch (error) {
        } finally {
        }
    };

    const createWallet = async () => {
        setLoadingSave(true);
        const token = localStorage.getItem('damavandclub-token')
        try {
            await axios.post(`${baseURL}/Wallet/create`, WalletModel, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            toast.success('ذخیره شد', {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
            setData([]);
            setFilter((current) => ({ ...current, skip: 0 }));
            setLoading(true);
            setReload(true);
            setLoadingSave(false);
            setIsShowCreateWalletModalVisible(false)
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            toast.error(error.response.data.Msg, {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
            setLoadingSave(false);
        } finally {
            setLoadingSave(false);
        }
    };

    const getFinancialReport = async () => {

        setLoadingFinancialReport(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getFinancialReport`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }, 'responseType': 'blob'
            });
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');

            setLoadingFinancialReport(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoadingFinancialReport(false);
        } finally {
            setLoadingFinancialReport(false);
        }
    };

    const showCreateWalletModal = async () => {
        setWalletModel({})
        setIsShowCreateWalletModalVisible(true)
    };

    return (
        <div>
            {permissions.includes('viewfinancialreport') && <Button className="members-wallet-action members-wallet-report" onClick={() => getFinancialReport()} loading={loadingFinancialReport}
                style={{ marginTop: 10, width: '100%' }}
                type="primary"><label>گزارش مالی</label></Button>}

            {permissions.includes('createwallet') ? <Button className="members-wallet-action members-wallet-create" onClick={() => showCreateWalletModal()} style={{ marginTop: 10, width: '100%', marginBottom: 10 }}
                type="primary"><label>ایجاد کیف پول</label></Button> : null}

            <HideSidebarInMobileMode />
            <Collapse defaultActiveKey={['0']}>
                <Collapse.Panel header='جستجو ' key='1'>
                    <Select
                        style={{ width: '100%', marginTop: 10 }}
                        placeholder="انتخاب عضو"
                        allowClear={true}
                        showSearch
                        optionFilterProp="label"
                        onChange={(value) => {
                            setFilter({ ...filter, data: { ...filter.data, userId: value } })
                        }}
                    //value={WalletModel.userId}
                    >
                        {dropDownUser?.map((item) => (
                            <Option key={item.id} label={item.displayName} value={item.id}>
                                {item.displayName}
                            </Option>
                        ))}
                    </Select>
                    <Select
                        style={{ width: '100%', marginTop: 10 }}
                        placeholder="انتخاب نوع تراکنش"
                        allowClear={true}
                        onChange={(value) => {
                            setFilter({ ...filter, data: { ...filter.data, walletType: value } })
                        }}
                        value={WalletModel.walletType}
                    >
                        {dropDownWalletType?.map((item) => (
                            <Option key={item.id} value={item.id}>
                                {item.displayName}
                            </Option>
                        ))}
                    </Select>
                    <Button className="members-wallet-action members-wallet-search" onClick={() => {
                        setData([]);
                        setFilter((current) => ({ ...current, skip: 0 }));
                        setLoading(true);
                        setReload(true);
                    }} loading={loading} style={{ marginTop: 10, width: '100%', marginBottom: 10 }}
                        type="primary"><label>جستجو</label></Button>
                    {/* <Button onClick={() => getExcel()} loading={loadingExcel} style={{ backgroundColor: 'rgb(229 131 27)', marginTop: 10, width: '100%', marginBottom: 10 }}
                        type="primary"><label>خروجی اکسل</label></Button> */}
                </Collapse.Panel>
            </Collapse>


            {loading && !loadingMore ? <div className="my-wallet-transactions-loading"><Spin size="large" /></div> : data.length > 0 ?
                <div className="my-wallet-transaction-grid members-wallet-transaction-grid">
                    {data.map((record, index) => (
                        <article className={`my-wallet-transaction-card ${record.increaseMode ? 'is-credit' : 'is-debit'}`} key={record.key || record.id || index}>
                            <div className="my-wallet-transaction-card-top">
                                <span className="members-wallet-member-name">{record.userFullName || 'عضو'}</span>
                                <span className="my-wallet-transaction-index">#{index + 1 + filter.limit * filter.skip}</span>
                            </div>
                            <div className="my-wallet-transaction-direction-row">
                                <span className="my-wallet-transaction-direction">{record.increaseMode ? '↑ افزایش موجودی' : '↓ کاهش موجودی'}</span>
                            </div>
                            <div className="my-wallet-transaction-amount-row">
                                <div className="my-wallet-transaction-amount-label">مبلغ تراکنش</div>
                                <div className="my-wallet-transaction-amount"><AmountFormat amount={record.amount} /><span>ریال</span></div>
                            </div>
                            <div className="my-wallet-account-balance-row">
                                <span>مانده حساب</span>
                                <strong><AmountFormat amount={record.accountBalance} /> <small>ریال</small></strong>
                            </div>
                            <div className="my-wallet-transaction-details">
                                {record.walletTypeTitle ? <div><span>نوع تراکنش</span><strong>{record.walletTypeTitle}</strong></div> : null}
                                {record.description ? <div><span>توضیحات</span><strong>{record.description}</strong></div> : null}
                                {record.creatorName ? <div><span>ایجادکننده</span><strong>{record.creatorName}</strong></div> : null}
                                {record.persianCreateDate ? <div><span>تاریخ ثبت</span><strong>{record.persianCreateDate}</strong></div> : null}
                            </div>
                        </article>
                    ))}
                </div> : !loading ? <div className="my-wallet-transactions-empty">تراکنشی برای نمایش وجود ندارد</div> : null}
            {loadingMore && <div className="members-wallet-load-more"><Spin size="small" /></div>}
            <div className="members-wallet-total">
                <span>تعداد کل کیف پول‌ها</span>
                <strong>{count}</strong>
            </div>
            <Modal
                className="create-wallet-modal"
                title={`ایجاد کیف پول`}
                open={isShowCreateWalletModalVisible}
                width={1000}
                closable={false}
                okButtonProps={null}
                footer={<div className='row-container create-wallet-footer'>
                    <Button onClick={() => {
                        setWalletModel({})
                        setIsShowCreateWalletModalVisible(false)
                    }} style={{ width: '100%' }}>بستن</Button>
                    <Button className="create-wallet-save" type="primary" loading={loadingSave}
                        onClick={() => createWallet()}
                        style={{ width: '100%', marginRight: 10 }}>ذخیره</Button>
                </div>}
            >
                <div className="create-wallet-fields">
                    <InputNumberFormat value={WalletModel.amount} placeholder="مبلغ (ریال) با اعداد انگلیسی"
                        onValueChange={(value) => setWalletModel({ ...WalletModel, amount: value })} />
                    <Select
                        placeholder="انتخاب نوع تراکنش"
                        onChange={(value) => setWalletModel({ ...WalletModel, walletType: value })}
                        value={WalletModel.walletType}
                    >
                        {dropDownWalletType?.map((item) => <Option key={item.id} value={item.id}>{item.displayName}</Option>)}
                    </Select>
                    <Select
                        placeholder="انتخاب عضو"
                        showSearch
                        optionFilterProp="label"
                        onChange={(value) => setWalletModel({ ...WalletModel, userId: value })}
                        value={WalletModel.userId}
                    >
                        {dropDownUser?.map((item) => <Option key={item.id} label={item.displayName} value={item.id}>{item.displayName}</Option>)}
                    </Select>
                    <input
                        placeholder='توضیحات'
                        value={WalletModel.description}
                        onChange={(event) => setWalletModel({ ...WalletModel, description: event.target.value })} />
                </div>
            </Modal>
        </div>
    )
}

export default MembersWallet
